import { StatusBar } from "expo-status-bar";
import React, { useRef, useState } from "react";
import {
  StyleSheet,
  Text,
  View,
  TouchableOpacity,
  Dimensions,
  Image,
  TextInput,
  FlatList,
} from "react-native";
import Modal from "modal-react-native-web";
import { Octicons } from "@expo/vector-icons";
import moment from "moment";
import { apiservice } from "../../service/service";
import { useRecoilValue } from "recoil";
import { tokenState } from "../../reducer/reducer/reducer/Atom";
const { width, height } = Dimensions.get("window");
export default function table({ data, navigation, onSuccess }) {
  const token = useRecoilValue(tokenState);
  const [state, setState] = useState();
  const [deletes, setDelete] = useState("");
  const [modals, setModal] = useState(false);

  return (
    <View style={styles.back}>
      <Modal
        animationType="slide"
        transparent={true}
        visible={modals}
        onRequestClose={() => {
          Alert.alert("Modal has been closed.");
          setModal(!modals);
        }}
      >
        <View style={styles.backmodal}>
          <View style={styles.viewmodal}>
            <Text style={styles.textdel}>
              พิมพ์คำว่า DELETE แล้วกดปุ่มยืนยัน เพื่อต้องการลบ ID นี้
            </Text>
            <TextInput
              value={deletes}
              onChangeText={setDelete}
              style={styles.inputmodal}
            />
            <View
              style={{
                flexDirection: "row",
                marginTop: 20,
                alignSelf: "flex-end",
              }}
            >
              <TouchableOpacity
                onPress={() => setModal(!modals)}
                style={styles.touchadd1}
              >
                <Text style={styles.textadd}>ยกเลิก</Text>
              </TouchableOpacity>
              <TouchableOpacity
                onPress={async () => {
                  const res = await apiservice({
                    path: "/freepoint/deletefreepoint?id=" + state?.id,
                    method: "delete",
                    token: token?.accessToken,
                  });

                  if (res.status == 200) {
                    onSuccess();
                    setModal(!modals);
                  }
                }}
                style={[styles.touchadd1, { marginHorizontal: 25 }]}
              >
                <Text style={styles.textadd}>ยืนยัน</Text>
              </TouchableOpacity>
            </View>
          </View>
        </View>
      </Modal>
      <View style={styles.head}>
        <View
          style={[styles.viewhead, { width: "30%",  }]}
        >
          <Text style={styles.texthead}>รายการ</Text>
        </View>
        <View style={[styles.viewhead, { width: "15%" }]}>
          <Text style={styles.texthead}>วันที่สร้าง</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>สถานะ</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>ของรางวัล</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>เวลา</Text>
        </View>
        <View style={[styles.viewhead, { width: "10%" }]}>
          <Text style={styles.texthead}>จำนวนครั้งที่แสดง</Text>
        </View>

        <View style={[styles.viewhead, { width: "15%" }]}>
          <Text style={styles.texthead}>ข้อมูล</Text>
        </View>
      </View>
      <FlatList
        data={data}
        scrollEnabled={false}
        renderItem={({ index, item }) => {
          return (
            <View>
              <View
                style={[
                  styles.viewmain,
                  {
                    backgroundColor: index % 2 ? "#F1F2F4" : "#fff",
                    height: null,
                  },
                ]}
              >
                <View
                  style={[
                    styles.viewdetail,
                    {
                      width: "30%",
                      justifyContent: "flex-start",
                      alignItems: "center",
                    },
                  ]}
                >
                  <Image
                    resizeMode={"contain"}
                    source={{
                      uri:  item.url,
                    }}
                    style={styles.img}
                  />
                  <View>
                    <Text
                      style={[
                        styles.textdeil,
                        { marginLeft: 10,},
                      ]}
                    >
                      {item.name}
                    </Text>
                    <Text
                      style={[
                        styles.textdetail,
                        { marginLeft: 10,width: "40%",  },
                      ]}
                    >
                      {item.description}
                    </Text>
                  </View>
                </View>
                <View style={[styles.viewdetail, { width: "15%" }]}>
                  <Text style={styles.textdate}>
                    {moment(item.startDate).format("DD/MM/YYYY")}
                  </Text>
                </View>
                <View style={[styles.viewdetail, {  width: "10%" }]}>
                  <Octicons
                    name="dot-fill"
                    size={16}
                    color={item.Type == "Active" ? "#2DCE98" : "red"}
                    style={{ alignSelf: "center", marginRight: 10 }}
                  />
                  <Text style={styles.textdate}>{item.Type}</Text>
                </View>
                <View style={[styles.viewdetail, {  width: "10%" }]}>
                  <Image
                    style={{ width: 50, height: 50, alignSelf: "center" }}
                    source={require("../../image/coin.png")}
                  />
                </View>
                <View style={[styles.viewdetail, {  width: "10%" }]}>
                  <Text style={styles.textdate}>30 วินาที</Text>
                </View>
                <View style={[styles.viewdetail, {  width: "10%"}]}>
                  <Text style={styles.textdate}>{item.count}</Text>
                </View>
                <View style={[styles.viewdetail, {  width: "15%" }]}>
                  <TouchableOpacity
                    onPress={() => navigation.navigate("CreateFreepoint", item)}
                    style={styles.touchedit}
                  >
                    <Text style={[styles.texthead, { fontSize: 14 }]}>
                      EDIT
                    </Text>
                  </TouchableOpacity>
                  <TouchableOpacity
                    onPress={() => {
                      setState(item);
                      setModal(true);
                    }}
                    style={[styles.touchedit, { marginLeft: 15 }]}
                  >
                    <Text style={[styles.texthead, { fontSize: 14 }]}>
                      DELETE
                    </Text>
                  </TouchableOpacity>
                </View>
              </View>
            </View>
          );
        }}
      />
    </View>
  );
}
const styles = StyleSheet.create({
  back: {
    width: "100%",
    height: "80%",
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
  },
  head: {
    width: "100%",
    height: 50,
    flexDirection: "row",
    backgroundColor: "#F1F3F9",
    justifyContent: "space-between",
  },
  viewhead: {
    paddingLeft: 10,
    justifyContent: "center",
  },
  texthead: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewdetail: {
    flexDirection: "row",
    justifyContent: "center",
  },
  img: {
    width: 100,
    height: 100,
  },
  textdeil: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#393939",
    marginTop: 5,
  },
  textdetail: {
    fontFamily: "Prompt-Regular",
    fontSize: 12,
    color: "#393939",
  },
  viewmain: {
    flexDirection: "row",
    width: "100%",
    height: 80,
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewatc: {
    width: width * 0.18,
    height: 30,
    justifyContent: "space-between",
    alignSelf: "flex-end",
    marginBottom: 20,
    flexDirection: "row",
    marginRight: 20,
  },
  touchatc: {
    width: 30,
    height: 30,
    borderRadius: 15,
    borderWidth: 0.5,
    borderColor: "#8898AA",
    justifyContent: "center",
  },
  textatc: {
    fontFamily: "Prompt-Regular",
    fontSize: 15,
    color: "#7764E4",
    alignSelf: "center",
  },
  viewfree: {
    justifyContent: "space-between",
    width: width * 0.82,
    flexDirection: "row",
  },
  textfree: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#000",
    fontWeight: "bold",
    alignSelf: "center",
  },
  textfree1: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    alignSelf: "center",
  },
  touchadd: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
  },
  touchadd1: {
    width: 150,
    height: 40,
    justifyContent: "center",
    alignSelf: "center",
    borderRadius: 5,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
  },
  textadd: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#172B4D",
    alignSelf: "center",
  },
  viewfor: {
    width: width * 0.55,
    height: 150,
    backgroundColor: "#FFF",
    padding: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    borderRadius: 10,
  },
  textname: {
    fontSize: 18,
    color: "#000000",
    fontFamily: "Prompt-Regular",
  },
  textname1: {
    fontSize: 16,
    color: "#444444",
    fontFamily: "Prompt-Regular",
  },
  textname2: {
    fontSize: 16,
    color: "#000",
    fontFamily: "Prompt-Regular",
  },
  textdate: {
    fontFamily: "Prompt-Regular",
    fontSize: 16,
    color: "#172B4D",
    alignSelf: "center",
  },
  textfree2: {
    fontFamily: "Prompt-Regular",
    fontSize: 20,
    color: "#000",
    marginTop: 10,
  },
  view: {
    width: width * 0.82,
    borderWidth: 0.05,
    borderColor: "#00000010",
    backgroundColor: "#fff",
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    marginTop: 10,
    paddingHorizontal: 10,
    paddingVertical: 20,
    borderRadius: 10,
  },
  viewmainfor: {
    flexDirection: "row",
    width: width * 0.3,
    justifyContent: "space-between",
  },
  inputadd: {
    width: width * 0.16,
    height: 30,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  inputadd1: {
    width: width * 0.16,
    height: 100,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginBottom: 10,
  },
  viewevent: {
    width: width * 0.2,
    height: 100,
    backgroundColor: "#fff",
    borderRadius: 10,
    shadowColor: "#000",
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    padding: 20,
  },
  imgicon: {
    width: 50,
    height: 50,
    alignSelf: "flex-end",
    justifyContent: "center",
    borderRadius: 25,
    marginTop: -50,
  },
  text: {
    fontFamily: "Prompt-Regular",
    fontSize: 18,
    color: "#8898AA",
  },
  text1: {
    fontFamily: "Prompt-Regular",
    fontSize: 25,
    color: "#4D4F5C",
  },
  backmodal: {
    flex: 1,
    backgroundColor: "#000000bb",
    justifyContent: "center",
  },
  viewmodal: {
    width: width * 0.7,
    height: 250,
    backgroundColor: "#fff",
    borderRadius: 5,
    alignSelf: "center",
    padding: 10,
  },
  textdel: {
    fontFamily: "Prompt-Regular",
    fontSize: 35,
    color: "#000",
    alignSelf: "center",
  },
  inputmodal: {
    width: width * 0.65,
    height: 50,
    borderWidth: 1,
    borderColor: "#ccc",
    paddingLeft: 10,
    borderRadius: 5,
    color: "#777777",
    fontFamily: "Prompt-Regular",
    marginVertical: 10,
    alignSelf: "center",
  },
  touchedit: {
    width: 80,
    height: 30,
    borderWidth: 0.5,
    borderColor: "#DBDBDB",
    alignSelf: "center",
    justifyContent: "center",
    // marginLeft: -80,
  },
});
